import { User } from 'api/users/schemas/Users';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useNavigate } from 'react-router-dom';
import { UserActions } from 'screens/UserDetails/UserActions';

export const UsersActions = ({ row }: { row: User }) => {
  const navigate = useNavigate();

  return (
    <div className="flex gap-4">
      <GraniteButton
        variant="secondary"
        size="small"
        onClick={() => navigate(`/users/${row.email}`)}
      >
        View
      </GraniteButton>
      <UserActions status={row.status} id={row.id} />
    </div>
  );
};
